import React, { useEffect, useState } from 'react'
import { rolesByOrg } from '@vt/apis/lib-ex/v2/role'
import { orgTreeData } from '@vt/apis/lib-ex/v2/orgs'
import { Provider } from './context'

const OrgProvider = function ({ appId, children }) {
  const [roles, setRoles] = useState([])
  const { orgsData = [], orgMutate } = orgTreeData(appId)

  useEffect(() => {
    // 获取所有角色
    rolesByOrg(appId).then((data = []) => {
      setRoles(
        data.map((item) => {
          return { value: item.slug, label: item.name, id: item.id }
        })
      )
    })
  }, [])

  return (
    <Provider
      value={{ orgs: orgsData, roles: roles || [], fetchOrgs: orgMutate }}
    >
      {children}
    </Provider>
  )
}
export default OrgProvider
